import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VSheet, { staticClass: "container" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "text-center" },
          [
            _c(VProgressCircular, {
              attrs: { indeterminate: "", size: 50, color: "primary" },
            }),
          ],
          1
        )
      : _c("div", [
          _vm.worksheets && _vm.worksheets.length > 0 && _vm.selectedWorksheet
            ? _c(
                "div",
                [
                  _vm.override
                    ? _c(
                        VAlert,
                        {
                          staticClass: "mb-7 text-center",
                          attrs: { outlined: "", color: "warning" },
                        },
                        [_vm._v(" Override Mode ")]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-space-between my-5 flex-column flex-md-row",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-space-between" },
                        [
                          _vm.worksheets && _vm.worksheets.length > 1
                            ? _c(
                                VMenu,
                                {
                                  attrs: {
                                    "offset-y": "",
                                    "allow-overflow": "",
                                    "min-width": "380px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {},
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  VIcon,
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _vm._v(
                                                      " mdi-file-document-multiple-outline "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$vuetify.lang.t(
                                                        "$vuetify.worksheet.xJobsxWorksheets",
                                                        _vm.jobsCount,
                                                        _vm.worksheets.length
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    140608413
                                  ),
                                },
                                [
                                  _c(
                                    VList,
                                    _vm._l(_vm.jobs, function (group) {
                                      return _c(
                                        VListGroup,
                                        {
                                          key: group.id,
                                          attrs: {
                                            value: true,
                                            "no-action": "",
                                            "sub-group": "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      VListItemContent,
                                                      [
                                                        _c(
                                                          VListItemTitle,
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  group.jobName
                                                                ) +
                                                                " (" +
                                                                _vm._s(
                                                                  group.status
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  group
                                                                    .worksheets
                                                                    .length
                                                                ) +
                                                                " Worksheets)"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        _vm._l(
                                          group.worksheets,
                                          function (worksheet, index) {
                                            return _c(
                                              VListItem,
                                              {
                                                key: index,
                                                staticClass: "pl-5",
                                                attrs: { "two-line": "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.changeSelectedWorksheet(
                                                      worksheet
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VListItemAvatar,
                                                  [
                                                    _c(VChip, [
                                                      _vm._v(
                                                        _vm._s(
                                                          worksheet.entryCount
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VListItemContent,
                                                  [
                                                    _c(VListItemTitle, [
                                                      worksheet.processTypeName
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                worksheet.processTypeName
                                                              ) + " -"
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            worksheet.productName
                                                              ? `${worksheet.productName} (${worksheet.id})`
                                                              : `${worksheet.worksheetType} (${worksheet.id})`
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                    _c(
                                                      VListItemSubtitle,
                                                      {
                                                        staticClass:
                                                          "text-caption",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDateTime"
                                                            )(
                                                              worksheet.createTime
                                                            )
                                                          ) +
                                                            " (" +
                                                            _vm._s(
                                                              _vm.statusLang(
                                                                worksheet.status
                                                              )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.selectedWorksheet.id ==
                                                worksheet.id
                                                  ? _c(
                                                      VListItemAvatar,
                                                      [
                                                        _c(VIcon, [
                                                          _vm._v(
                                                            "mdi-checkbox-marked-circle-outline"
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "mt-2 font-weight-light" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.worksheet.worksheet"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(_vm.selectedWorksheet.id) +
                                      " "
                                  ),
                                ]
                              ),
                          _c(
                            "div",
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-4",
                                  attrs: {
                                    to: { name: "MyWorksheetHistory" },
                                    icon: "",
                                  },
                                },
                                [_c(VIcon, [_vm._v("mdi-history")])],
                                1
                              ),
                              _c(
                                VBtn,
                                {
                                  staticClass: "ml-4",
                                  attrs: { to: { name: "home" }, icon: "" },
                                },
                                [_c(VIcon, [_vm._v("mdi-home-outline")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "my-auto text-overline font-weight-bold mt-4 mt-md-0 text-center text-md-right",
                        },
                        [
                          _c("span", [
                            _vm.selectedWorksheet.processDirection &&
                            _vm.selectedWorksheet.processDirection == "Input"
                              ? _c("span", { staticClass: "mr-2" }, [
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.worksheet.in"
                                        )
                                      ) +
                                      ") "
                                  ),
                                ])
                              : _vm._e(),
                            _vm.selectedWorksheet.processDirection &&
                            _vm.selectedWorksheet.processDirection == "Output"
                              ? _c("span", { staticClass: "mr-2" }, [
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.$vuetify.lang.t(
                                          "$vuetify.worksheet.out"
                                        )
                                      ) +
                                      ") "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm.selectedWorksheet.processTypeName
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedWorksheet.processTypeName
                                  ) + " -"
                                ),
                              ])
                            : _vm._e(),
                          _vm.selectedWorksheet.supplierName
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.selectedWorksheet.supplierName) +
                                    " -"
                                ),
                              ])
                            : _vm._e(),
                          _vm.selectedWorksheet.customerName
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.selectedWorksheet.customerName) +
                                    " -"
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selectedWorksheet.productName
                                  ? `${_vm.selectedWorksheet.productName} (${_vm.selectedWorksheet.id})`
                                  : `${_vm.selectedWorksheet.worksheetType} (${_vm.selectedWorksheet.id})`
                              ) +
                              " "
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "d-flex justify-center text-caption",
                            },
                            [
                              _vm.selectedWorksheet.documentNumber
                                ? _c("span", [
                                    _vm._v(
                                      " Doc #: " +
                                        _vm._s(
                                          _vm.selectedWorksheet.documentNumber
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.selectedWorksheet.documentNumber
                                ? _c(VDivider, {
                                    staticClass: "mx-2",
                                    attrs: { vertical: "" },
                                  })
                                : _vm._e(),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDateTime")(
                                      _vm.selectedWorksheet.createTime
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("worksheet", {
                    key: _vm.selectedWorksheet.id,
                    attrs: { worksheet: _vm.selectedWorksheet },
                    on: {
                      "update:worksheet": function ($event) {
                        _vm.selectedWorksheet = $event
                      },
                      deleted: _vm.removeWorksheet,
                      updated: _vm.handleWorksheetUpdated,
                      jobUpdated: _vm.reloadWorksheets,
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "text-center text-h6" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t(
                        "$vuetify.worksheet.noActiveWorksheet"
                      )
                    ) +
                    " "
                ),
                _c(
                  "div",
                  { staticClass: "ma-8" },
                  [
                    _c(
                      VBtn,
                      {
                        staticClass: "ml-4",
                        attrs: { to: { name: "MyWorksheetHistory" } },
                      },
                      [
                        _c(VIcon, { staticClass: "mx-2" }, [
                          _vm._v("mdi-history"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.worksheet.myHistory"
                              )
                            )
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }